<div class="content-wrap">
  <div *ngIf="alarms$ | async as alarms">
    <div *ngIf="alarms?.length === 0" class="no-alarm">받은 알림이 없습니다.</div>
    <div class="alarms-wrap">
      <div *ngFor="let item of alarms">
        <div class="wrap">
          <div>
            <p class="m-0 title">{{ item.title }} ({{ item.dateCreated | date : 'YYYY.MM.dd HH:mm' }})</p>
            <p class="m-0">{{ item.content }}</p>
          </div>
          <button *ngIf="!item.readSwitch" class="btn btn-warning">new</button>
        </div>
      </div>
    </div>
  </div>
</div>
